import React, { useState, useEffect } from "react";
import { breads } from "./allBreadCrumbs";
import { css } from "@emotion/css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Select,
  Layout,
  Col,
  Tooltip,
  Row,
  Typography,
  Popconfirm,
  Flex,
} from "antd";
import { useSelector, useDispatch } from "react-redux";

import { adminGetAllCompanyAction } from "../../store/action/admin/employeesAction";
// import QrCodeModal from "../modals/shared/qrCodeModal";

import { getAllOnboardingTemplatesAction } from "../../store/action/admin/recruitmentAction";
import { getAllOnboardingTasksAction } from "../../store/action/admin/onboardingActions";
import AppHeaderIcons from "./appHeaderIcons";
import { TranslatorNavigationTag } from "../../languageTranslator/LanguageTranslatorTags";
import { allList } from "./SidebarContent";
import HeaderDrawer from "./HeaderDrawer";
import ElementIcon from "../../Theme/CustomIcons/Icons/Grid/ElementIcon";
import TimerIcon from "../../Theme/CustomIcons/Icons/Time/TimerIcon";
import CalculatorIcon from "../../Theme/CustomIcons/Icons/School,Learning/CalculatorIcon";
import BrifeCaseIcon from "../../Theme/CustomIcons/Icons/School,Learning/BrifeCaseIcon";
import BuildingsIcon from "../../Theme/CustomIcons/Icons/Building/BuildingsIcon";
import ProfileDropDown from "./ProfileDropDown";
import Element1Icon from "../../Theme/CustomIcons/Icons/Grid/Element1Icon";
import NotificationIcon from "../../Theme/CustomIcons/Icons/Notification/NotificationIcon";
import Notifications from "./Notifications";
import MagicIcon from "../../Theme/CustomIcons/Icons/CustomIcons/MagicIcon";
import SearchBar from "./searchbar";
import WeightIcon from "../../Theme/CustomIcons/Icons/Essetional/WeightIcon";
import DocumentTexIcon from "../../Theme/CustomIcons/Icons/ContentEdit/DocumentTextIcon";
import DrawerHeaderListView from "./DrawerHeaderListView";
import { breadCrumbsAction } from "../../store/action/admin/themeActions";
import LogoutIcon from "../../Theme/CustomIcons/Icons/Arrow/LogoutIcon";
import { sharedLogoutAction } from "../../store/action/shared/authAction";
const { Text } = Typography;
const { Option } = Select;
const { Header } = Layout;

function AppHeaderSimple(props) {
  const dispatch = useDispatch();
  const router = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [categoryName, setCategoryName] = useState({});
  const themeDefault = useSelector((state) => state.themeDefault);
  useEffect(() => {
    if (breads && breads.length) {
      const breadDetails = breads.find((a) => a?.title === props?.name);
      if (breadDetails) {
        setCategoryName({ name: breadDetails?.type, icon: breadDetails?.icon });
      }
    }
  }, []);

  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  let modules = [];
  if (sharedUserInfo?.payload?.company?.modules) {
    modules = sharedUserInfo.payload.company.modules;
  } else if (
    sharedUserInfo?.empCompanies &&
    sharedUserInfo.empCompanies.length > 0 &&
    sharedUserInfo.empCompanies[0]?.companyId?.modules
  ) {
    modules = sharedUserInfo.empCompanies[0].companyId.modules;
  }

  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;

  let userType = "";
  if (sharedUserInfo?.payload?.type) {
    userType = sharedUserInfo.payload.type;
  } else if (sharedUserInfo?.type) {
    userType = sharedUserInfo.type;
  }

  const roleFeatures = sharedUserInfo?.userAccess || [];
  let companyLogo = "";
  if (userType === "admin") {
    companyLogo = sharedUserInfo?.payload?.company?.logo?.url || "";
  } else if (
    sharedUserInfo?.empCompanies &&
    sharedUserInfo.empCompanies.length > 0
  ) {
    companyLogo = sharedUserInfo.empCompanies[0]?.companyId?.logo?.url || "";
  }

  let industry = [];
  if (sharedUserInfo?.payload?.company?.modules) {
    industry = sharedUserInfo.payload.company.modules;
  } else if (
    sharedUserInfo?.empCompanies &&
    sharedUserInfo.empCompanies.length > 0 &&
    sharedUserInfo.empCompanies[0]?.companyId?.modules
  ) {
    industry = sharedUserInfo.empCompanies[0].companyId.modules;
  }

  const [activeName, setActiveName] = useState("");

  const [current, setCurrent] = useState(
    pathname === "/" || pathname === ""
      ? `/${
          userType === "admin" || userType === "user" ? userType : "manager"
        }/dashboard`
      : pathname
  );

  useEffect(() => {
    if (location) {
      if (current !== pathname) {
        setCurrent(location.pathname);
      }
    }
  }, [location, current]);

  function handleClick(e) {
    setCurrent(e.key);
  }
  const [isVisible, setVisible] = useState(false);
  const [isMenuItem, setMenuItem] = useState("none");
  const [sidebarItems, setSidebarItems] = useState([]);

  const onCancel = () => {
    setVisible(false);
  };
  const showDrawer = () => {
    setVisible(true);
  };

  const onSideBarActive = (name) => {
    setActiveName(name);
  };
  const [iconSize, setIconSize] = useState("small");
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1400) {
        setIconSize("small1");
      } else if (window.innerWidth < 1500) {
        setIconSize("small2");
      } else {
        setIconSize("small");
      }
    };

    window.addEventListener("resize", handleResize);

    // Set the initial size based on the current window width
    handleResize();

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const items = [
      {
        id: "maxAI",
        icon: <MagicIcon width="2rem" height="2rem" />,
        label: <TranslatorNavigationTag>Ask Max</TranslatorNavigationTag>,
        label1: "Ask Max",
        // link: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
        show:
          userType !== "guest" &&
          userType !== "user" &&
          modules &&
          modules.length > 0 &&
          modules.includes("searchbar"),

        isLink: true,
        category: "ask max",
        onClick:
          isVisible === true
            ? (e) => {
                onCancel(e);
                showDrawer(e);
                onSideBarActive("AI");
              }
            : showDrawer,
      },

      {
        id: "dashboard",
        icon: <ElementIcon size="small" />,
        label: <TranslatorNavigationTag>Dashboard</TranslatorNavigationTag>,
        label1: "Dashboard",
        link: `/${userType === "admin" ? userType : "manager"}/dashboard/`,
        show: userType !== "guest" && userType !== "user",
        isLink: true,
        category: "none",
        onClick: () => {
          onCancel();
          onSideBarActive("dashboard");
        },
      },
      {
        id: "time",
        icon: (
          <TimerIcon size={"small"} />
          // <TimesheetIcon
          //   color={`${iconColor}`}
          //   // height={iconColor?.h}
          //   height={16}
          //   className="sidebar-icon-color"
          // />
        ),
        label1: "Time",
        label: <TranslatorNavigationTag>Time</TranslatorNavigationTag>,
        show:
          (industry.includes("time_tracking_desktop") ||
            industry.includes("time")) &&
          (userType === "admin" ||
            (userType !== "user" &&
              (roleFeatures?.includes("88") ||
                roleFeatures?.includes("89") ||
                roleFeatures?.includes("19") ||
                roleFeatures?.includes("20") ||
                roleFeatures?.includes("61") ||
                roleFeatures?.includes("21")))),
        isLink: false,
        onClick:
          isVisible === true
            ? (e) => {
                onCancel(e);
                showDrawer(e);
                onSideBarActive("time");
              }
            : showDrawer,
        category: "time",
      },
      {
        id: "payroll",
        key: `/${userType === "admin" ? userType : "manager"}/payroll/`,
        icon: <CalculatorIcon size="small" />,
        label: <TranslatorNavigationTag>Payroll</TranslatorNavigationTag>,
        label1: "Payroll",
        link: `/${userType === "admin" ? userType : "manager"}/payroll/`,
        show:
          userType !== "guest" &&
          userType !== "user" &&
          industry.includes("payroll") &&
          (userType === "admin" ||
            (userType !== "user" &&
              [
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "50",
                "51",
                "52",
                "53",
                "54",
                "55",
                "56",
                "57",
                "58",
                "59",
                "60",
                "74",
                "75",
                "76",
                "77",
                "105",
              ].some((feature) => roleFeatures?.includes(feature)))),
        isLink: false,
        category: "payroll",
        onClick:
          isVisible === true
            ? (e) => {
                onCancel(e);
                showDrawer(e);
                onSideBarActive("payroll");
              }
            : showDrawer,
      },
      {
        id: "recruitment",
        icon: <BrifeCaseIcon size="small" />,
        label: <TranslatorNavigationTag>Grow</TranslatorNavigationTag>,
        label1: "Recruitment",
        show:
          industry.includes("recruitment") &&
          (userType === "admin" ||
            userType === "guest" ||
            (userType !== "user" &&
              (roleFeatures?.includes("67") ||
                roleFeatures?.includes("68") ||
                roleFeatures?.includes("93") ||
                roleFeatures?.includes("69") ||
                roleFeatures?.includes("70")))),
        isLink: false,
        onClick:
          isVisible === true
            ? (e) => {
                onCancel(e);
                showDrawer(e);
                onSideBarActive("recruitment");
              }
            : showDrawer,
        category: "recruitment",
      },
      // {
      //   id: "training",
      //   key: `/${userType === "admin" ? userType : "manager"}/training/`,
      //   icon: (
      //     <div
      //       className={css`
      //         .anticon {
      //           font-size: clamp(10px, 2vw, 17px) !important;
      //         }
      //       `}
      //     >
      //       <WeightIcon size="small" />
      //     </div>
      //   ),
      //   label: <TranslatorNavigationTag>Training</TranslatorNavigationTag>,
      //   label1: "Training",
      //   link: `/${userType === "admin" ? userType : "manager"}/training/`,
      //   show:
      //     ((userType !== "guest" && userType === "admin") ||
      //       ["71", "72", "73"].some((feature) =>
      //         roleFeatures?.includes(feature)
      //       )) &&
      //     industry.includes("training"),
      //   isLink: true,
      //   category: "none",
      //   onClick: () => {
      //     onCancel();
      //     onSideBarActive("training");
      //   },
      // },
      {
        id: "report",
        key: `/${userType === "admin" ? userType : "manager"}/report/`,
        icon: <DocumentTexIcon size="small" />,
        label: <TranslatorNavigationTag>Report</TranslatorNavigationTag>,
        label1: "Report",
        link: `/${userType === "admin" ? userType : "manager"}/report/`,
        show:
          ((userType !== "guest" && userType === "admin") ||
            ["63", "64"].some((feature) => roleFeatures?.includes(feature))) &&
          industry.includes("report"),
        isLink: true,
        category: "report",
        onClick: () => {
          onCancel();
          onSideBarActive("report");
        },
      },
      {
        id: "company",
        icon: <BuildingsIcon size="small" />,
        label: <TranslatorNavigationTag>Company</TranslatorNavigationTag>,
        label1: "Company",
        isLink: false,
        show: userType !== "guest" && userType !== "user",
        onClick:
          isVisible === true
            ? (e) => {
                onCancel(e);
                showDrawer(e);
                onSideBarActive("company");
              }
            : showDrawer,
        category: "organization",
      },
    ];
    setSidebarItems(items);
  }, [translations]);

  useEffect(() => {
    if (!isVisible) {
      let currentLocationName = "";

      allList &&
        allList?.length > 0 &&
        allList?.forEach((a) => {
          if (location.pathname?.includes(a)) {
            currentLocationName = a;
          }
        });
      const locationMappings = {
        dashboard: "dashboard",
        activity: "time",
        project: "time",
        "leave-request": "time",
        "leave-category": "time",
        "leave-calendar": "time",
        "leave-settings": "time",
        "expense-category": "time",
        "expense-settings": "time",
        "individual-leave-settings": "time",
        "public-holidays": "time",
        "timesheet/:userId": "time",
        leaves: "time",
        shift: "time",
        "my-leaves": "time",
        timesheet: "time",
        "qr-code-settings": "time",
        "qr-code": "time",
        "work-status": "time",
        "leave-history": "time",
        "expense-history": "payroll",
        "expense-request": "payroll",
        "payroll-basic-settings": "payroll",
        "salary-breakdown": "payroll",
        "payroll-employee-details": "payroll",
        "payroll-additional-pay": "payroll",
        "salary-components": "payroll",
        "salary-structure": "payroll",
        "payroll-leave": "payroll",
        "payroll-process-hours": "payroll",
        "payroll-review": "payroll",
        tax: "payroll",
        "payroll-preview": "payroll",
        payroll: "payroll",
        "payroll-air-ticket": "payroll",
        recruitment: "recruitment",
        "job-posts/edit": "recruitment",
        "job-posts/create": "recruitment",
        "job-posts/duplicate": "recruitment",
        "job-posts": "recruitment",
        "onboarding-templates": "recruitment",
        "onboarding-tasks": "recruitment",
        "talent-pool": "recruitment",
        "recruitment-companies": "recruitment",
        training: "recruitment",
        "performance-management": "recruitment",
        "job-ad-posts": "recruitment",
        "stage-templates": "recruitment",
        "email-templates": "company",
        "user-role": "company",
        "bulk-import": "company",
        "all-imports": "company",
        "email-signature": "company",
        "organization-basic-settings": "company",
        // "organization-settings": "company",
        "manage-branches": "company",
        "custom-fields": "company",
        "office-settings": "company",
        employees: "company",
        "service-request": "company",
        "help-desk": "company",
        "travel-desk": "company",
        teams: "company",
        "employee-hierarchy": "company",
        // announcement: "company",
        "company-resources": "company",
        "hr-letter": "company",
        "reports/checkin": "report",
        "report-history": "report",
        "reports/employee-asset-report": "report",
        "reports/employee-nationality-report": "report",
        "reports/employee-gender-report": "report",
        "reports/employee-age-report": "report",
        "reports/document-report": "report",
        "reports/leave-balance": "report",
        "reports/expense-report": "report",
        "reports/payroll-sheet": "report",
        "payroll-sheet": "report",
        "organization-settings": "settings",
        settings: "settings",
      };
      const trimmedCurrent = current
        ? current
            .replace(/^\/|\/$/g, "")
            .replace(/^admin\/?/, "")
            .replace(/^manager\/?/, "")
            .replace(/\/[a-zA-Z0-9]{5}$/, "")
        : "";
      let parentCrumb = locationMappings[trimmedCurrent];
      try {
        dispatch(breadCrumbsAction(parentCrumb));
      } catch (error) {
        console.log({ error });
      }
      setActiveName(
        locationMappings[currentLocationName] || currentLocationName
      );
    }
  }, [isVisible]);

  const getAllCompanyList = useSelector((state) => state.getAllCompanyList);

  const { getAllCompaniesLoading, getAllCompaniesInfo } = getAllCompanyList;
  const { onboardingTemplatesList } = useSelector(
    (state) => state.getAllOnboardingTemplatesList
  );
  const { onboardingTasksList } = useSelector(
    (state) => state.getAllOnboardingTasksList
  );

  useEffect(() => {
    if (!getAllCompaniesInfo) {
      dispatch(adminGetAllCompanyAction());
    }
    if (!onboardingTasksList) {
      dispatch(getAllOnboardingTasksAction());
    }
    if (!onboardingTemplatesList) {
      dispatch(getAllOnboardingTemplatesAction());
    }
  }, []);
  // State variable for header height
  const [headerHeight, setHeaderHeight] = useState(60);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 0) {
        // if (isVisible) {
        setHeaderHeight(60); // Decrease header height on scroll
        // }
      } else {
        setHeaderHeight(60); // Original header height
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isVisible &&
        !document.getElementById("drawer")?.contains(event.target) &&
        !document.querySelector(".maxai")?.contains(event.target) &&
        !document.getElementById("header")?.contains(event.target)
      ) {
        onCancel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, onCancel]);
  let viewType = "boxView";
  // let viewType = "listView";
  return (
    <>
      <div
        className={css`
          .antd-drawer {
            z-index: 100 !important;
          }
        `}
      >
        {viewType === "listView" ? (
          <DrawerHeaderListView
            activeName={activeName}
            current={current}
            handleClick={handleClick}
            isMenuItem={isMenuItem}
            isVisible={isVisible}
            onCancel={onCancel}
          />
        ) : (
          <HeaderDrawer
            activeName={activeName}
            onCancel={onCancel}
            current={current}
            handleClick={handleClick}
            isMenuItem={isMenuItem}
            isVisible={isVisible}
          />
        )}
      </div>
      <div
        id="header"
        className={css`
          // @media (max-width: 750px) {
          //   display: none !important;
          // }
          margin-bottom: 8px;
          z-index: 999 !important;
          width: 100%;
          position: fixed;

          top: -19px !important;
          left: 0;
          ${isVisible === true ? `position: fixed; top: 0; left: 0;` : ""}
        `}
      >
        \
        {/* {
        type:purple
        theme:purpletheme
      } */}
        <Header
          // className="theme-header-bg"
          className={css`
            background: ${themeDefault?.info?.newConfig?.cardBackground};
            backdrop-filter: blur(${themeDefault?.info?.newConfig?.cardBlur});
            border-bottom: solid 1px
              ${themeDefault?.info?.themeColor === "purple"
                ? "rgba(255, 255, 255, 0.14)"
                : themeDefault?.info?.themeColor === "dark"
                ? "rgba(255, 255, 255, 0.14)"
                : themeDefault?.info?.themeColor === "default"
                ? "#f5f4f6"
                : "#f5f4f6"};
            position: sticky;
            transition: height 0.3s ease-in-out; /* Add transition for the icon */

            height: 60px !important;
            @media (max-width: 1500px) {
              height: 50px;
            }
            @media (max-width: 1300px) {
              height: 40px;
            }
          `}
        >
          {props?.fromOnboarding ? (
            <Row>
              <Col
                span={12}
                className={css`
                  display: flex !important;
                  align-items: center !important;
                `}
              >
                <Link
                  to={`/${
                    userType === "admin"
                      ? "admin"
                      : userType === "manager"
                      ? "manager"
                      : userType === "user" && "user"
                  }/dashboard`}
                >
                  <img
                    alt="logo"
                    src={`/max-new-logo.png`}
                    className={css`
                      height: clamp(50px, 4vw, 60px);
                    `}
                  />
                </Link>
              </Col>

              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={css`
                  display: flex;
                  justify-content: flex-end;
                `}
              >
                <ProfileDropDown fromOnboarding={props?.fromOnboarding} />
              </Col>
            </Row>
          ) : userType === "Kiosk" ? (
            <Row>
              <Col
                span={12}
                className={css`
                  display: flex !important;
                  align-items: center !important;
                `}
              >
                <Link
                  to={`/${
                    userType === "admin"
                      ? "admin"
                      : userType === "manager"
                      ? "manager"
                      : userType === "user" && "user"
                  }/dashboard`}
                >
                  <img
                    alt="logo"
                    src={`/pics/max-new-logo.png`}
                    className={css`
                      height: clamp(50px, 4vw, 60px);
                    `}
                  />
                </Link>
              </Col>

              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={css`
                  display: flex;
                  justify-content: flex-end;
                  .anticon {
                    color: ${themeDefault?.info?.newConfig?.color};
                  }
                `}
              >
                <Popconfirm
                  placement="bottomLeft"
                  title={"Logout"}
                  description={"Are you sure to logout?"}
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => dispatch(sharedLogoutAction())}
                >
                  <LogoutIcon style={{ fontSize: "26px" }} />
                </Popconfirm>
              </Col>
            </Row>
          ) : (
            <Row
              className={css`
                justify-content: space-between !important;
              `}
            >
              <Col
                flex="none"
                className={css`
                  display: flex !important;
                  align-items: center !important;
                `}
              >
                {/* <Link to={"/admin/dashboard"}>
                  <img
                    alt="logo"
                    // src={`/max-new-logo.png`}
                    src="/logos/max.png"
                    className={css`
                      height: clamp(20px, 4vw, 60px);
                    `}
                  />
                </Link> */}

                <Link to={"/dashboard/"}>
                  <Flex align="center">
                    <img
                      alt="logo"
                      src={`/max-new-logo.png`}
                      className={css`
                        height: clamp(50px, 4vw, 60px);
                      `}
                    />
                    {themeDefault?.info?.themeColor === "default" ? (
                      <img
                        alt="logo"
                        src={`/max-dark.png`}
                        className={css`
                          height: 15px;
                        `}
                      />
                    ) : (
                      <img
                        alt="logo"
                        src={`/max-white.png`}
                        className={css`
                          height: 15px;
                        `}
                      />
                    )}
                  </Flex>
                </Link>
              </Col>
              {/* <Col
                flex="auto"
                className={css`
                  display: flex !important;
                  align-items: center !important;
                  gap: 10px;
                  justify-content: center !important;
                  .ant-drawer .ant-drawer-mask {
                    z-index: 999 !important;
                  }
                `}
              >
                {sidebarItems.map((item, index) => {
                  return (
                    <AppHeaderIcons
                      isVisible={isVisible}
                      item={item}
                      activeName={activeName}
                      setMenuItem={setMenuItem}
                      onSideBarActive={onSideBarActive}
                      onCancel={onCancel}
                    />
                  );
                })}
              </Col> */}
              <Col flex="none" style={{ display: "flex" }}>
                <Row
                  gutter={[16, 16]}
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {(sharedUserInfo?.payload?.type === "admin" &&
                      modules?.includes("time_tracking_mobile")) ||
                    (userType !== "user" &&
                      roleFeatures?.includes("66") &&
                      props.qr !== "no-qr") ? (
                      // <span className={[giftSpan]}>
                      <Tooltip title="Company's QR Code" placement="bottom">
                        {/* <QrCodeModal /> */}
                      </Tooltip>
                    ) : (
                      // </span>
                      <></>
                    )}
                  </Col>

                  {/* <Col>
                    {modules?.includes("announcement") ? (
                      <>
                        <Notifications />
                      </>
                    ) : (
                      <></>
                    )}
                  </Col> */}

                  <Col>
                    <ProfileDropDown />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Header>
      </div>
    </>
  );
}
export default AppHeaderSimple;
